<template>
	<Datepicker input-class="date_int" :typeable="false" :language="en" :value="dateValue" format="MM-yyyy" :highlighted="highlighted" @input="updateValue" minimum-view="month"></Datepicker>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { en } from 'vuejs-datepicker/dist/locale';

export default {
	props: ['value'],
	name: 'customMonthPicker',
	data: function() {
		return {
			en: en,
			highlighted: {
				dates: [new Date()],
			},
		};
	},
	components: {
		Datepicker,
	},
	computed: {
		dateValue() {
			if (this.value) {
				const m = moment(this.value, 'MM-YYYY', true);
				return m.isValid() ? m.toDate() : null;
			}
			return null;
		},
	},
	methods: {
		updateValue: function(event) {
			this.$emit('input', this.valueFormat(event));
		},
		valueFormat(date) {
			if (date == null) return null;
			var inputDate = new Date(date);
			return moment(inputDate).format('MM-yyyy');
		},
	},
};
</script>

<style>
.vdp-datepicker {
	display: inline-block;
}
</style>
